import { useTranslation } from 'react-i18next'
import { Button, IconButton } from '~/shared/ui/Buttons'
import { HistoryEduIcon } from '~/shared/ui/Icons'
import { Modal, useModal } from '~/shared/ui/Modal'
import { List } from './ui/List'

type HistoryChangesProps = {
  auditableId: UniqueId
}

export function AuditsModal({ auditableId }: HistoryChangesProps) {
  const { t } = useTranslation()
  const { isModalShow, openModal, closeModal } = useModal()

  return (
    <>
      <IconButton
        data-testid='audit-button'
        onClick={openModal}
        tooltipProps={{ title: t('change history') }}
      >
        <HistoryEduIcon />
      </IconButton>

      <Modal
        isShow={isModalShow}
        onCancel={closeModal}
        dialogProps={{
          sx: {
            minWidth: '1000px',
            maxWidth: '1000px',
          },
        }}
        title={t('change history')}
      >
        <List auditableId={auditableId} />
        <br />
        <Button variant='gray' onClick={closeModal} fullWidth>
          {t('button.close')}
        </Button>
      </Modal>
    </>
  )
}
